import { Box } from '@mui/material';
import PrimarySearchAppBar from "../components/PrimarySearchAppBar";
import { useAuth0 } from "@auth0/auth0-react";
import { ResultJSON } from '../components/ResultJSON';
import { FIPOKGames } from '../components/FIPOKGames';
import { Domains } from '../Utils';

export const GamesPage = () => {
	const auth0Obj = useAuth0();
	const isAuthenticated = auth0Obj.isAuthenticated;
	console.log("isAuth: ", isAuthenticated);

	return (
		<Box>
			<PrimarySearchAppBar />
			{!isAuthenticated && (
				<Box>
					A tartalom megtekintéséhez be kell jelentkeznie.
					You are not authenticated. Log in to see the contents.

				</Box>
			)}
			{isAuthenticated && (
				<div>
					<ResultJSON bucketBaseURL={Domains.gamesURL} code={'games'}>
						<FIPOKGames section={'cognitive'} />
					</ResultJSON>
					<ResultJSON bucketBaseURL={Domains.gamesURL} code={'games'}>
						<FIPOKGames section={'coordination'} />
					</ResultJSON>
				</div>
			)}
		</Box>
	);
};
